import Vue from 'vue'
import router from '@/router'
import VueRouterMiddleware from 'vue-router-middleware'

Vue.use(VueRouterMiddleware, {
    router,
})

import '@/router/middlewares'